<div style="max-width:1100px; margin:20px auto; font-family:Arial;">

  <div style="
    background:linear-gradient(135deg,#0f4c81,#1e6bb8);
    color:white;
    padding:20px;
    border-radius:10px;
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
  ">

    <div>
      <h2 style="margin:0;">Request #{{ request?.id }}</h2>

      <div style="font-size:13px; opacity:0.9; margin-top:4px;">
        Created {{ request?.createdAt | date:'medium' }}
      </div>
      <div style="font-size:13px; opacity:0.9;">
        By {{ request?.createdBy?.firstName }} {{ request?.createdBy?.lastName }}
      </div>
      @if(request != null && request.updatedBy != null && request.updatedAt != null) {
      <div style="font-size:13px; opacity:0.9;">
        Last Updated {{ request.updatedAt | date:'medium' }}
      </div>
      <div style="font-size:13px; opacity:0.9;">
        By {{ request.updatedBy.firstName }} {{ request.updatedBy.lastName }}
      </div>
      }



      <div style="margin-top:10px; font-size:14px;">
        Assigned To:
        <b>
          {{
          request != null && request.assignedTo != null
          ? request.assignedTo.firstName + ' ' + request.assignedTo.lastName
          : 'Unassigned'
          }}
        </b>

        <button mat-flat-button style="margin-left:10px; background-color: #c5af22;" (click)="openAssignDialog()">

          Assign
        </button>
      </div>
    </div>

    <div style="text-align:right;">
      <div style="
        display:inline-block;
        padding:6px 12px;
        border-radius:20px;
        background:#22c55e;
        font-weight:600;
        margin-bottom:6px;
      ">
        {{ request?.status }}
      </div>

      <div [style]="getPriorityStyle(request?.priority)" style="
             display:block;
             padding:6px 12px;
             border-radius:20px;
             font-weight:600;
           ">
        Priority: {{ request?.priority }}
      </div>
    </div>

  </div>

  <div style="
    display:grid;
    grid-template-columns:repeat(2,1fr);
    gap:16px;
    margin-top:16px;
  ">

    <div class="card">
      <div class="label">Location</div>
      <div class="value">{{ request?.location?.name }}</div>
    </div>

    <div class="card">
      <div class="label">Equipment</div>
      <div class="value">{{ request?.equipmentMachine?.name || 'N/A' }}</div>
    </div>

    <div class="card">
      <div class="label">Cause</div>
      <div class="value">{{ request?.maintenanceCause?.name }}</div>
    </div>

    <div class="card">
      <div class="label">Sub Cause</div>
      <div class="value">{{ request?.maintenanceSubCause?.name || 'N/A' }}</div>
    </div>

  </div>

  <div class="card" style="margin-top:16px;">
    <div class="label">Description</div>
    <div class="value">{{ request?.description }}</div>
  </div>

  <div style="margin-top:12px; display:flex; gap:10px; flex-wrap:wrap;">

    <span class="chip">
      Operational: {{ request?.isOperational ? 'Yes' : 'No' }}
    </span>

    <span class="chip">
      Tagged Out: {{ request?.isTaggedOut ?? 'N/A' }}
    </span>

    <span class="chip">
      LOTO: {{ request?.isLOTOFollowed ?? 'N/A' }}
    </span>

  </div>

  <div class="card" style="margin-top:16px;">
    <div class="label">Attachments</div>

    <div style="display:flex; gap:10px; flex-wrap:wrap; margin-top:10px;">

      @for (file of request?.files ?? []; track file.id) {
      <img [src]="file.url" (click)="openImage(file.url)" style="
            width:120px;
            height:120px;
            object-fit:cover;
            border-radius:8px;
            cursor:pointer;
            border:1px solid #e5e7eb;
          " />
      }

      @if ((request?.files?.length ?? 0) === 0) {
      <div style="color:#6b7280;">No attachments</div>
      }

    </div>
  </div>

  <div style="margin-top:20px; display:flex; gap:10px;">

    <button mat-flat-button [style.background]="activeTab === 'logs' ? '#0f4c81' : '#ddd'"
      [style.color]="activeTab === 'logs' ? 'white' : '#475569'" (click)="activeTab = 'logs'">
      Logs
    </button>

    <button mat-flat-button [style.background]="activeTab === 'history' ? '#0f4c81' : '#ddd'"
      [style.color]="activeTab === 'history' ? 'white' : '#475569'" (click)="activeTab = 'history'">
      History
    </button>
  </div>


  @if(activeTab == 'history') {
  <div class="card" style="margin-top:16px;">
    <div class="label">History</div>
    @for (h of request?.histories ?? []; track h.id) {
    <div style="border-left:3px solid #0f4c81; padding-left:10px; margin:10px 0;">

      <div style="font-size:12px; color:#6b7280;">
        {{ h.createdAt | date:'medium' }}
      </div>

      <div>
        Status:
        <b>{{ h.oldStatus }} → {{ h.newStatus }}</b>
      </div>

      <div>
        Priority:
        <b>{{ h.oldPriority || '-' }} → {{ h.newPriority || '-' }}</b>
      </div>

      <div>
        Assigned:
        <b>
          {{
          h.oldAssignedTo
          ? h.oldAssignedTo.firstName + ' ' + h.oldAssignedTo.lastName
          : '-'
          }}
          →
          {{
          h.newAssignedTo
          ? h.newAssignedTo.firstName + ' ' + h.newAssignedTo.lastName
          : '-'
          }}
        </b>
      </div>
      @if(h.note){
      <div>
        Note: {{ h.note }}
      </div>
      }


      <div style="font-size:12px; color:#888;">
        By {{ h.createdBy.firstName }} {{ h.createdBy.lastName }}
      </div>

    </div>
    }

  </div>
  }

  @if (activeTab == 'logs') {
  <div class="card" style="margin-top:16px;">
    <div class="label">Logs</div>

    @for(l of request?.logs; track $index) {
    <div style="padding:10px; border-bottom:1px solid #eee;">

      <div style="font-size:12px; color:#6b7280;">
        {{ l.createdAt | date:'medium' }}
      </div>

      <div>
        Status: <b>{{ l.status }}</b>
      </div>
      @if (l.note) {
      <div>
        Note: {{ l.note }}
      </div>
      }
      @if (l.files.length) {
      <div style="margin-top:10px; display:flex; gap:8px; flex-wrap:wrap;">
        @for(img of l.files; track $index) {
        <img [src]="img.url" (click)="openImage(img.url)" style="
          width:80px;
          height:80px;
          object-fit:cover;
          border-radius:6px;
          cursor:pointer;
          border:1px solid #e5e7eb;
        " />
        }


      </div>
      }

      <div style="font-size:12px; color:#888;">
        By {{ l.createdBy.firstName }} {{ l.createdBy.lastName }}
      </div>

    </div>
    }

  </div>
  }

</div>